import React, { useState, useEffect, useCallback } from "react";
import Navmenu from "../Navmenu";
import Appbar from "../Appbar";
import "../../style/ArticleMain.scss";
import { Row, Col, List } from "bootstrap-4-react";
import Footer from "../Footer";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import { Bookmark, BookmarkBorder } from "@material-ui/icons";
import ShareNews from "../../govt-circular-gr/ShareNews";
import axios from "axios";
import { apiURL, getID } from "../../utils";
import SanitizedHTML from "react-sanitized-html";
import Moment from "moment";
import Meta from "../../meta/Meta";
import Rating from "../Rating";
import { IconButton, Container } from "@material-ui/core";
import Comments from "./Comments";
import OtherArticle from "./OtherArticle";
import NoDataFound from "../../common/NoDataFound";

const styles = (theme) => ({
  root: {
    maxWidth: "100%",
  },
  buttonContainer: {
    display: "flex",
    flexWrap: "nowrap",
    width: "100%",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
});

const SingleBlog = (props) => {
  const [articleData, setArticleData] = useState({});
  const [noData, setNoData] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [is_bookmark, setIs_bookmark] = useState(false);
  const [loading, setLoading] = useState(true);
  //new state added to show the error if there is no data found
  const [noResult, setNoResult] = useState(false);


  const { classes, match, history, location } = props;

  const articleListData = useCallback(() => {
    console.log("singleblog", match.params.blogId);
    const headers = {
      "Content-type": "application/json",
    };
    const body = {
      id: match.params.blogId,
      category_id: "",
      user_id: getID(),
    };
    axios
      .post(apiURL("blog/get_all_blog?per_page=" + 1 + "&page=" + 1), body, {
        headers,
      })
      .then((response) => {
        const resultData = response.data;

        if (
          (resultData.status === true || resultData.status === 1) &&
          resultData.result &&
          resultData.result.length > 0
        ) {
          const articleData = resultData.result[0];
          setArticleData(articleData);
          setIs_bookmark(articleData.is_bookmark || false);
          setNoResult(false);
        } else {
          setArticleData({});
          setNoResult(true);
        }

        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setNoResult(true);
        setLoading(false);
      });

  }, [match.params.blogId]);

  useEffect(() => {
    const element = document.getElementById("blogs-smooth-scroll");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" }); // Fallback to top scroll
    }

    setIsMobile(window.innerWidth <= 1000);
    articleListData();
  }, [articleListData]);

  useEffect(() => {
    const element = document.getElementById("blogs-smooth-scroll");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" }); // Fallback to top scroll
    }

    articleListData();
  }, [match.params.blogId, articleListData]);


  const handleAddBookMark = (id) => {
    const headers = {
      "content-type": "application/json",
      Accept: "application/json",
    };
    const body = {
      content_id: id,
      content_type: "blogs",
      user_id: getID(),
    };
    axios
      .post(apiURL("bookmark/addBookmark"), body, { headers })
      .then((response) => {
        const resultData = response.data;
        if (resultData.success === true || resultData.success === 1) {
          setIs_bookmark(true);
        } else {
          console.log("error");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleRemoveBookMark = (id) => {
    const headers = {
      "content-type": "application/json",
      Accept: "application/json",
    };
    const body = {
      content_id: id,
      content_type: "blogs",
      user_id: getID(),
    };
    axios
      .post(apiURL("bookmark/removeBookmark"), body, { headers })
      .then((response) => {
        const resultData = response.data;
        if (resultData.status === true || resultData.status === 1) {
          setIs_bookmark(false);
        } else {
          console.log("error");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleBack = () => {
    history.push("/blogs");
  };
  return (
    <>
      <Meta
        tableName={"blog"}
        objectId={match.params.blogId}
        forPage={"inner_page"}
      />

      <Appbar />
      <div className="sticky-top sign-light">
        <Navmenu />
      </div>
      {loading ? (
        <div className="text-center py-5">Loading...</div>
      ) : noResult ? (
        <section className="articleSingle">
          <Container maxWidth="lg">
            <NoDataFound message="This blog is no longer available." />

            {/* <div className="articleBack mt-4">
              <Button onClick={handleBack}>Back</Button>
            </div> */}
          </Container>
        </section>
      ) : (
        <>
          <section
            className="BannerBox articleBanner"
            id="blogs-smooth-scroll"
          >
            <div className="sixteen-nine">
              <div className="content text-center text-white invisible">
                <h2>Past Training Schedule</h2>
                <p>PAST TRAINING SCHEDULE TO FEED YOUR BRAIN</p>
              </div>
            </div>
          </section>

          <section className="articleSingle">
            <Container maxWidth="lg">
              <h1>{articleData.fldv_title}</h1>

              <Row>
                <Col sm="12">
                  <div className="fixed-content">
                    {/* <SanitizedHTML
                      allowedAttributes={false}
                      allowedTags={false}
                      html={articleData.fldt_description}
                    /> */}
                     {/*updated html */}
                  <SanitizedHTML
                    allowedTags={[
                      "div", "table", "tbody", "thead", "tr", "td", "th",
                      "p", "span", "b", "i", "strong", "em", "ul", "ol", "li", "br","img","a"
                    ]}
                    allowedAttributes={{
                      div: ["class"],
                      table: ["class"],
                      td: ["colspan", "rowspan"],
                      th: ["colspan", "rowspan"],
                      img: ["src", "alt", "width", "height", "style"],
                      a: ["href", "target", "rel"]
                    }}
                    allowedSchemesByTag={{ img: ["http", "https"],a: ["http", "https"] }}
                    html={articleData.fldt_description}
                  />
                  </div>  
                </Col>
              </Row>
            </Container>
          </section>
          <section className="articleAction">
            <Container className="mt-5" maxWidth="lg">
              <div className="actionArtSingle">
                {is_bookmark ? (
                  <IconButton
                    className="bookmark"
                    style={{
                      color: "orange",
                      border: "3px solid #064e89",
                    }}
                    onClick={() =>
                      handleRemoveBookMark(articleData.fldi_id)
                    }
                  >
                    <Bookmark />
                  </IconButton>
                ) : (
                  <IconButton
                    className="bookmark"
                    style={{
                      color: "#064e89",
                      border: "3px solid #064e89",
                    }}
                    onClick={() =>
                      handleAddBookMark(articleData.fldi_id)
                    }
                  >
                    <BookmarkBorder />
                  </IconButton>
                )}

                <div className="rating">
                  <Rating
                    blogId={articleData.fldi_id}
                    userId={getID()}
                    rating={articleData.rating}
                    color="gold"
                  />
                </div>
              </div>

              <div className="share">
                <ShareNews
                  blogId={articleData.fldi_id}
                  shareUrl={window.location.href}
                  title={articleData.fldv_title}
                  date={Moment(
                    articleData.fldv_select_date
                  ).format("dddd, D MMM, YYYY")}
                  time={Moment(
                    articleData.fldv_from_time
                  ).format("hh:mmA")}
                />
              </div>
            </Container>
          </section>
          <Comments
            blogId={articleData.fldi_id}
            category_id={articleData.category_id}
          />
          <Container>
            <div className="articleBack">
              <Button onClick={handleBack}>Back</Button>
            </div>
          </Container>
        </>
      )}
      {!loading && (
        <OtherArticle
          category_id={articleData?.category_id || ""}
          id={articleData?.fldi_id || ""}
          history={history}
          category_name={location?.state?.category}
        />
      )}

      <Footer />
    </>
  );

};

export default withStyles(styles)(SingleBlog); 